import React from "react";
import Select from "react-select";
import { getItemsGroup } from "../../utils/url";
import PriorityContainer from "../PriorityContainer/PriorityContainer";

export default function PriorityComponentFilter({ item, onDataChange, index }) {
  const handleOnChange = (val) => {
    onDataChange(index, val.value, "priority");
  };
  return (
    <div style={{width:"120px"}}>
      {/* <PriorityContainer
        isActive={true}
        size={"30px"}
        canEdit={true}
        index={-1}
        concatVal={"Priority"}
        task={{ priority: item.priority }}
        handlePriorityChange={handleOnChange}
      /> */}
      <Select
        options={[
          { label: "Low", value: 1 },
          { label: "Medium", value: 2 },
          { label: "Urgent", value: 3 },
          { label: "None", value: 0 },
        ]}
        value={item.priority}
        onChange={handleOnChange}
      />
    </div>
  );
}
